
export function statusOptions() {
  return [{ id : 1, name : '正常' }, { id : 2, name : '停用' }]
}


export function modelOptions() {
  return [{ id : 0, name : '线下' }, { id : 1, name : '混合' }]
}
export function classStatus() {
  return [{ id : 1, name : '未开始' }, { id : 2, name : '进行中' }, { id : 3, name : '已结束' }, { id : 4, name : '已停用' }]
}
export function classMonth() {
  return [{ id : 1, name : '1月' }, { id : 2, name : '2月' }, { id : 3, name : '3月' }, { id : 4, name : '4月' },
    { id : 5, name : '5月' }, { id : 6, name : '6月' }, { id : 7, name : '7月' }, { id : 8, name : '8月' }, { id : 9, name : '9月' },
    { id : 10, name : '10月' }, { id : 11, name : '11月' }, { id : 12, name : '12月' }]
}

export function classPhase() {
  return [{ id : 1, name : '计划' }, { id : 2, name : '实施' }, { id : 3, name : '延期' }]
}


export function radioYesNO() {
  return [{ id : 0, name : '否' }, { id : 1, name : '是' }]
}

// 节点类型
export function scheduleType() {
  return [{ value : 1, label : '普通节点' }, { value : 2, label : '面授课' }, { value : 3, label : '签到' }, { value : 4, label : '作业' },
    { value : 5, label : '问卷' }, { value : 6, label : '资源' }]
}

// 参与学员
export function joinType() {
  return [{ value : 1, label : '全班' }, { value : 2, label : '指定小组' }, { value : 3, label : '指定学员' }]
}

// 参与学员
export function sendWay() {
  return [{ value : 1, label : '立即发布' }, { value : 2, label : '定时发布' }]
}

// 参与学员
export function signWay() {
  return [{ "label": "其他方式（例如纸质）", "value": 1 },{ "label": "静态二维码", "value": 2 },{ "label": "动态二维码", "value": 3 },]
}


export function isCheck() {
  return [{ 'value' : 0, 'label' : '否' }, { 'value' : 1, 'label' : '是' }]
}

